<template>
  <div style="background-color: #F5F7FA;height: 100%;">
    <div style="padding: 0px;position: relative;">
      <template>
        <el-table ref="myTable" class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="hh" border>

          <el-table-column prop="userName" label="姓名"></el-table-column>
          <el-table-column prop="value" label="甘油三酯"></el-table-column>
          <el-table-column prop="deviceType" label="来源"></el-table-column>
          <el-table-column label="异常">
            <template slot-scope="scope">
              <span v-if="scope.row.isNormal == 0">异常</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="时间" :formatter="timefilter"></el-table-column>

          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>

        </el-table>
        <div class="page">
          <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination small
                           background
                           layout="prev, pager, next"
                           :total="totalItems"
                           :page-size="20"
                           :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="float: right">
            <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>
          </div>
          <div style="clear: both;"></div>
        </div>
      </template>
    </div>

    <GYSZhiAdd ref="myGYSZhiAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false"
              v-on:resultSuccess="resultSuccess"></GYSZhiAdd>

  </div>
</template>

<script>


import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import GYSZhiAdd from "./GYSZhiAdd";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "BloodPressureAndHeartRate",
  data() {
    return {
      tableLoading:false,
      showModalAdd:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      userCode: '',
      hh:this.$store.state.tableHeight-170,

    }
  },
  components: {
    GYSZhiAdd
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.hh = val - 170;
    },
    '$store.state.tableWidth' : function(val){
      console.log(val);
    },
  },

  methods: {
    init(userCode) {
      this.userCode = userCode;
      this.getList();
    },
    closeSelf() {
      this.$emit("closeBlood");
    },


    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myGYSZhiAdd.init(this.userCode);
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    resultSuccess(){
      this.currentPage = 1;
      this.getList();
    },

    getList(){
      let that = this;
      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DataAll/PageByUserCodeDeviceTypeValueType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          deviceType: '',
          valueType:7,
          userCode: this.userCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then(
          (response) => {
            this.tableLoading=false
            if (response.data.error === 0) {
              this.tableData=response.data.data.pageInfo.list;
              this.totalItems=response.data.data.pageInfo.total

              this.$nextTick(()=>{
                this.$refs.myTable.doLayout()
              })


            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },

    //日期格式
    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },
    handleDelete(index,row){

      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$deviceUrl + "DataAll/Delete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            dataAllCode:row.dataAllCode,

          }
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {

            this.getList();

          } else if (response.data.error == 1) {
            this.$message({type: 'info', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(e => e)

    },



  }


}
</script>

<style lang="scss" scoped>


</style>
